var mcb = mcb || {};

mcb.scrollto = mcb.scrollto ||
  new function () {
    this.init = function () {
      const header = document.querySelector(".primary-nav");
      const elements = document.querySelectorAll(
        "button[data-scroll-to-target]"
      );

      for (var elem of elements) (function(elem) {
        var scrollTargetName = elem.getAttribute("data-scroll-to-target");
        var scrollTaget = document.querySelector(scrollTargetName);
        if (scrollTaget) {
          elem.addEventListener("click", () => clickHandler(scrollTaget));
        }
      })(elem)

      function clickHandler(elm) {
        const offset = elm.offsetTop - header.offsetHeight - 100;
        window.scrollTo(0, offset);
      }
    };
  }();
